module.exports = __webpack_public_path__ + "static/media/insideout-logo-wit.9c61b00a.svg";